import { render, staticRenderFns } from "./car-type-list.vue?vue&type=template&id=220247bc&scoped=true&"
import script from "./car-type-list.vue?vue&type=script&lang=js&"
export * from "./car-type-list.vue?vue&type=script&lang=js&"
import style0 from "./car-type-list.vue?vue&type=style&index=0&id=220247bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220247bc",
  null
  
)

export default component.exports